import { Landmark, LineChart, Check } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Field } from "@/components/FormBits";

const PRODUCTS = [
  { id: "checking_investing", title: "Total Checking + Self-Directed Investing", desc: "Everyday banking plus a brokerage account to buy and sell stocks.", icons: [Landmark, LineChart] },
  { id: "checking", title: "Total Checking", desc: "Everyday banking with Zelle, bill pay and transfers.", icons: [Landmark] },
];

export const StepProduct = ({ f, set }) => (
  <div className="grid gap-3" data-testid="step-product">
    {PRODUCTS.map((p) => (
      <button type="button" key={p.id} onClick={() => set("product")(p.id)} className={`text-left border rounded-xl p-5 flex gap-4 items-start transition-colors ${f.product === p.id ? "border-[var(--blue)] bg-blue-50/60" : "hover:border-slate-300"}`} data-testid={`product-${p.id}`}>
        <div className="flex gap-1">{p.icons.map((I, i) => <div key={i} className="h-10 w-10 rounded-full bg-white border text-[var(--blue)] grid place-items-center"><I size={18} /></div>)}</div>
        <div className="flex-1"><div className="font-display font-semibold text-[var(--navy)]">{p.title}</div><div className="text-sm text-slate-500">{p.desc}</div></div>
        {f.product === p.id && <Check className="text-[var(--blue)]" />}
      </button>
    ))}
    <p className="text-xs text-slate-500">No minimum opening deposit. Your accounts open with a $0.00 balance.</p>
  </div>
);

const inp = (f, set, k, props = {}) => <Input value={f[k]} onChange={(e) => set(k)(e.target.value)} required data-testid={`signup-${k}-input`} {...props} />;

export const StepPersonal = ({ f, set }) => (
  <div className="grid sm:grid-cols-2 gap-4" data-testid="step-personal">
    <div className="sm:col-span-2"><Field label="Full legal name">{inp(f, set, "name")}</Field></div>
    <Field label="Date of birth">{inp(f, set, "dob", { type: "date" })}</Field>
    <div />
    <div className="sm:col-span-2"><Field label="Home street address">{inp(f, set, "street")}</Field></div>
    <Field label="City">{inp(f, set, "city")}</Field>
    <div className="grid grid-cols-2 gap-3">
      <Field label="State">{inp(f, set, "state", { maxLength: 2, placeholder: "NY" })}</Field>
      <Field label="ZIP">{inp(f, set, "zip", { inputMode: "numeric", maxLength: 10 })}</Field>
    </div>
  </div>
);

export const StepContact = ({ f, set }) => (
  <div className="grid gap-4" data-testid="step-contact">
    <Field label="Email">{inp(f, set, "email", { type: "email" })}</Field>
    <Field label="Mobile phone">{inp(f, set, "phone", { type: "tel", placeholder: "(555) 555-5555" })}</Field>
    <p className="text-xs text-slate-500">We'll email you a 6-digit code to verify it's you.</p>
  </div>
);

export const StepLogin = ({ f, set }) => (
  <div className="grid gap-4" data-testid="step-login">
    <Field label="Choose a username">{inp(f, set, "username", { autoComplete: "username" })}</Field>
    <div className="grid sm:grid-cols-2 gap-4">
      <Field label="Password">{inp(f, set, "password", { type: "password", autoComplete: "new-password" })}</Field>
      <Field label="Confirm password">{inp(f, set, "confirm", { type: "password", autoComplete: "new-password" })}</Field>
    </div>
    <label className="flex gap-3 items-start text-sm text-slate-600 mt-2">
      <Checkbox checked={f.agree} onCheckedChange={(v) => set("agree")(!!v)} data-testid="signup-agree-checkbox" />
      I agree to the Maderian Us Serve account agreement, privacy notice and electronic communications terms.
    </label>
  </div>
);
